<template>
  <RouterView v-slot="{ Component }">
    <template v-if="Component">
      <component :is="Component" />
    </template>
  </RouterView>
</template>

<script lang="ts" setup>
  import { useAppPagePaths, useGlobalStore } from '@shared/store';
  import { useWxJsSdk, useMockLogin, usePageChangeVisible } from '@shared/hooks';

  const globalStore = useGlobalStore();
  // 加载微信/企微 sdk
  if (import.meta.env.VITE_WX_JS_SDK_ENABLED === 'on') {
    const { isSupported } = useWxJsSdk({
      onLoaded: (el) => {
        console.log('WxJsSdk Loaded');
        globalStore.setFirstEntryPageUrl();
      },
    });
  }
  // 获取路由白名单配置
  if (import.meta.env.VITE_ROUTE_PATH_CHECK === 'on') {
    useAppPagePaths().init(`fe-caizhi-webapp-${import.meta.env.VITE_APP_NAME}`, {
      currentCorpId: globalStore.appData.currentCorpId,
    });
  }

  // 模拟登录
  useMockLogin();
  usePageChangeVisible();
</script>

<style lang="less">
  // 覆盖被 Vant 影响的全局字体设置
  body {
    font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif, '宋体';
  }
</style>
